/*
 * KO · Barra de compra fija (móvil) + "sin talla preseleccionada" en la ficha de producto.
 *
 * 1) GATE DE TALLA: el tema (Prestige) renderiza en servidor la primera variante disponible (p.ej. talla M).
 *    Aquí quitamos esa marca visual mientras el cliente no haya elegido talla, cambiamos el botón a
 *    "Elige tu talla" y bloqueamos el envío del formulario hasta que elija. Solo afecta a opciones de talla
 *    marcadas desde Liquid con [data-ko-size-option] (ficha principal, producto con >1 variante).
 *    Productos Default Title / una sola variante: no se tocan. Si la URL trae ?variant=, se considera elegida.
 * 2) BARRA FIJA: <ko-sticky-atc> aparece cuando el botón original sale de pantalla. Envía el formulario real
 *    (requestSubmit), así el carrito (drawer/página), packs y variantes se comportan igual que el botón original.
 */
(function () {
  if (window.__koStickyAtc) return;
  window.__koStickyAtc = true;

  var S = {
    chosen: {},          // posiciones de opción de talla elegidas por el cliente
    allChosen: false,    // llegó con ?variant= en la URL
    gated: false,
    missing: [],
    busy: false,
    pending: false,      // el cliente tocó una opción y el tema aún no ha resuelto la variante (form id desfasado)
    inited: false
  };
  var pendingTimer;
  function setPending(v) {
    S.pending = v;
    window.clearTimeout(pendingTimer);
    // El temporizador solo limpia el aspecto "cargando"; el bloqueo de compra lo decide resolved(), no este flag
    if (v) pendingTimer = window.setTimeout(function () { S.pending = false; reflect(); }, 8000);
  }

  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  function picker() { return document.querySelector('variant-picker[context="main_product"]'); }
  function formId() {
    var p = picker();
    if (p) return p.getAttribute('form-id');
    var b = document.querySelector('ko-sticky-atc'); // productos de una sola variante: no hay selector
    return b ? b.getAttribute('form') : null;
  }
  function sizeFieldsets() {
    var p = picker();
    return p ? Array.prototype.slice.call(p.querySelectorAll('fieldset[data-ko-size-option]')) : [];
  }
  function bar() { return document.querySelector('ko-sticky-atc'); }
  function str(name, fallback) { var b = bar(); return (b && b.getAttribute('data-label-' + name)) || fallback; }
  function submitButtons() {
    var id = formId();
    if (!id) return [];
    return Array.prototype.slice.call(document.querySelectorAll('buy-buttons[form="' + id + '"] button[type="submit"]'));
  }
  function mainButton() {
    var id = formId();
    if (!id) return null;
    return document.querySelector('[data-block-type="buy-buttons"] buy-buttons[form="' + id + '"] button[type="submit"]') || submitButtons().filter(function (b) { return !b.closest('product-sticky-bar'); })[0] || null;
  }
  // Referencia de posición del botón original. Con la variante agotada, Klaviyo sustituye el botón por su "Avísame":
  // por eso se mide el formulario completo, que siempre existe.
  function anchor() {
    var id = formId();
    return (id && document.forms[id]) || mainButton();
  }
  function notifyTrigger() {
    return document.querySelector('.klaviyo-bis-trigger');
  }

  /* ------------------------------------------------------------------ gate */
  function applyGate() {
    var fieldsets = sizeFieldsets();
    var p = picker();
    // Llegada con ?variant= VÁLIDO (Liquid lo confirma con product.selected_variant): la talla cuenta como elegida
    if (!S.inited && p) {
      S.inited = true;
      S.allChosen = !!p.getAttribute('data-ko-selected');
    }
    var productAvailable = !p || p.getAttribute('data-ko-available') !== 'false';
    var missing = [];

    if (productAvailable) {
      fieldsets.forEach(function (f) {
        var pos = f.getAttribute('data-ko-position');
        if (S.allChosen || S.chosen[pos]) return;
        missing.push(f);
        Array.prototype.forEach.call(f.querySelectorAll('input[type="radio"]'), function (i) {
          if (i.checked) i.checked = false;
        });
      });
    }

    S.missing = missing;
    S.gated = missing.length > 0;
    reflect();
  }

  function reflect() {
    document.documentElement.classList.toggle('ko-size-gated', S.gated);
    document.documentElement.classList.toggle('ko-size-pending', S.pending);
    // Compra dinámica (Shop Pay/Apple Pay...) fuera mientras falte talla o la variante no esté resuelta; sin depender de temporizadores
    document.documentElement.classList.toggle('ko-size-block', S.gated || !resolved());
    var plural = S.missing.length > 1;
    var labelGate = plural ? str('sizes', 'Elige tus tallas') : str('size', 'Elige tu talla');

    // Botones de envío del tema (principal y barra superior de escritorio)
    submitButtons().forEach(function (b) {
      if (S.gated) {
        if (b.dataset.koOrig === undefined) {
          b.dataset.koOrig = b.textContent;
          b.dataset.koDis = b.disabled ? '1' : '0';
        }
        if (b.textContent !== labelGate) b.textContent = labelGate;
        b.disabled = false;
        b.classList.add('ko-needs-size');
      } else if (b.dataset.koOrig !== undefined) {
        b.textContent = b.dataset.koOrig;
        b.disabled = b.dataset.koDis === '1';
        delete b.dataset.koOrig;
        delete b.dataset.koDis;
        b.classList.remove('ko-needs-size');
      }
    });

    // Avisos de talla: fuera cuando ya no faltan
    sizeFieldsets().forEach(function (f) {
      if (S.missing.indexOf(f) === -1) {
        var h = f.querySelector('.ko-size-hint');
        if (h) h.remove();
        f.classList.remove('ko-nudge');
      }
    });

    // Barra fija
    var b = bar();
    if (!b) return;
    var cta = b.querySelector('[data-ko-cta]');
    var ctaLabel = b.querySelector('[data-ko-cta-label]');
    var chip = b.querySelector('[data-ko-size-chip]');
    var chipValue = b.querySelector('[data-ko-size-value]');
    var availability = b.getAttribute('data-available'); // true | false | none (combinación inexistente)
    var soldOut = availability === 'false';
    var nonexistent = availability === 'none';

    b.classList.toggle('is-gated', S.gated);

    // Precio "Desde" mientras no hay talla y el precio varía
    var from = b.querySelector('[data-ko-from]');
    var now = b.querySelector('[data-ko-now]');
    var was = b.querySelector('[data-ko-was]');
    if (from) {
      from.hidden = !S.gated;
      if (now) now.hidden = S.gated;
      if (was) was.hidden = S.gated;
    }

    b.classList.toggle('is-pending', S.pending);
    if (S.busy) b.querySelector('[data-ko-cta]').setAttribute('aria-busy', 'true');
    if (S.busy || b.classList.contains('is-done')) return;

    if (S.gated) {
      ctaLabel.textContent = labelGate;
      cta.disabled = false;
      chip.hidden = true;
    } else {
      var picked = sizeFieldsets().map(function (f) {
        var c = f.querySelector('input:checked');
        if (!c) return '';
        // El nombre de la talla sale del JSON de la variante (la etiqueta incluye tablas de medidas de apps)
        var pos = parseInt(f.getAttribute('data-ko-position'), 10);
        try {
          var json = JSON.parse(picker().querySelector('script[data-variant]').textContent);
          if (json.options && json.options[pos - 1]) return String(json.options[pos - 1]);
        } catch (e) {}
        var l = c.labels && c.labels[0];
        var node = l && l.firstChild;
        return node && node.textContent ? node.textContent.replace(/\s+/g, ' ').trim() : '';
      }).filter(Boolean);
      if (picked.length) {
        chipValue.textContent = picked.join(' · ');
        chip.hidden = false;
      } else {
        chip.hidden = true;
      }
      var notify = soldOut ? notifyTrigger() : null;
      if (nonexistent) {
        ctaLabel.textContent = str('unavailable', 'No disponible');
        cta.disabled = true;
        cta.removeAttribute('data-ko-notify');
      } else if (notify) {
        // Variante agotada con "Avísame" de Klaviyo: la barra lo reutiliza en vez de quedarse muerta
        ctaLabel.textContent = str('notify', 'Avísame');
        cta.disabled = false;
        cta.setAttribute('data-ko-notify', '');
      } else {
        ctaLabel.textContent = soldOut ? str('soldout', 'Agotado') : str('add', 'Añadir');
        cta.disabled = soldOut;
        cta.removeAttribute('data-ko-notify');
      }
    }
  }

  function nudge() {
    var targets = S.missing.length ? S.missing : sizeFieldsets();
    var first = targets[0];
    if (!first) return;
    var plural = S.missing.length > 1;
    var hintText = plural ? str('hints', 'Elige tus tallas para añadirlo a la cesta') : str('hint', 'Elige tu talla para añadirlo a la cesta');

    first.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'center' });

    targets.forEach(function (f) {
      var h = f.querySelector('.ko-size-hint');
      if (!h) {
        h = document.createElement('p');
        h.className = 'ko-size-hint';
        h.setAttribute('role', 'alert');
        var values = f.querySelector('.variant-picker__option-values');
        if (values) f.insertBefore(h, values); else f.appendChild(h);
      }
      h.textContent = hintText;
      f.classList.remove('ko-nudge');
      void f.offsetWidth; // reinicia la animación
      f.classList.add('ko-nudge');
      window.setTimeout(function () { f.classList.remove('ko-nudge'); }, 1400);
    });

    var firstInput = first.querySelector('input[type="radio"]');
    if (firstInput) { try { firstInput.focus({ preventScroll: true }); } catch (e) {} }
    if (navigator.vibrate) { try { navigator.vibrate(12); } catch (e) {} }
  }

  /* ----------------------------------------------------------- visibilidad */
  var ticking = false;
  function updateVisibility() {
    ticking = false;
    var b = bar();
    var root = document.documentElement;
    if (!b) { root.classList.remove('ko-sticky-on'); return; }
    var btn = anchor();
    var show = false;
    if (btn && window.scrollY > 80) {
      var r = btn.getBoundingClientRect();
      show = r.bottom < 0 || r.top > window.innerHeight;
    }
    var footer = document.querySelector('.shopify-section--footer');
    if (show && footer && footer.getBoundingClientRect().top < window.innerHeight) show = false;

    b.classList.toggle('is-visible', show);
    root.classList.toggle('ko-sticky-on', show);
    if (show) {
      var h = b.offsetHeight;
      if (h) root.style.setProperty('--ko-sticky-h', h + 'px');
    }
  }
  function schedule() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateVisibility);
  }

  /* --------------------------------------------------------------- eventos */
  // El cliente elige talla: se registra ANTES de que el tema pida el re-render
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest || !t.matches || !t.matches('input[type="radio"][data-option-position]')) return;
    var p = picker();
    if (!p || !p.contains(t)) return;
    var f = t.closest('fieldset[data-ko-size-option]');
    if (f) S.chosen[f.getAttribute('data-ko-position')] = true;
    // Hasta que el tema resuelva la variante (variant:change) el formulario sigue con el ID anterior
    if (!t.hasAttribute('data-product-url')) setPending(true);
    applyGate();
  }, true);

  // Bloquea el envío mientras falte talla (captura: llega antes que <product-form>)
  document.addEventListener('submit', function (e) {
    var id = formId();
    if (!id || !e.target || e.target.getAttribute('id') !== id) return;
    if (S.gated) {
      e.preventDefault();
      e.stopImmediatePropagation();
      nudge();
      return;
    }
    if (!purchaseConsistent()) {
      // Variante aún sin resolver o desincronizada con lo marcado: no se compra una talla distinta de la elegida
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  // Lo marcado en pantalla debe coincidir con la variante YA resuelta por el tema, y el ID del formulario ser el de esa variante.
  // Es la guarda real contra enviar un ID antiguo (no depende de temporizadores): si la respuesta tarda, sigue bloqueado.
  function resolved() {
    var p = picker();
    var id = formId();
    var form = id && document.forms[id];
    if (!p || !form) return true; // una sola variante: nada que comprobar
    var sv = p.selectedVariant;
    if (!sv || !sv.id || !sv.options) return false;
    if (String(sv.id) !== String(form.elements.id && form.elements.id.value)) return false;
    var inputs = Array.prototype.slice.call(p.querySelectorAll('input[type="radio"][data-option-position]:checked'));
    var positions = {};
    for (var i = 0; i < inputs.length; i++) {
      var pos = parseInt(inputs[i].getAttribute('data-option-position'), 10);
      positions[pos] = true;
      var name = inputs[i].getAttribute('data-ko-name');
      if (name !== null && String(sv.options[pos - 1]).trim().toLowerCase() !== name.trim().toLowerCase()) return false;
    }
    return sizeFieldsets().every(function (f) { return positions[parseInt(f.getAttribute('data-ko-position'), 10)]; });
  }
  function purchaseConsistent() { return resolved(); }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var chip = t.closest('[data-ko-size-chip]');
    if (chip) {
      var f = sizeFieldsets()[0];
      if (f) {
        f.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'center' });
        var inp = f.querySelector('input[type="radio"]:checked') || f.querySelector('input[type="radio"]');
        if (inp) { try { inp.focus({ preventScroll: true }); } catch (err) {} }
      }
      return;
    }
    var cta = t.closest('[data-ko-cta]');
    if (!cta || cta.disabled || S.busy) return;
    if (S.gated) { nudge(); return; }
    if (cta.hasAttribute('data-ko-notify')) {
      var trig = notifyTrigger();
      if (trig) trig.click();
      return;
    }
    var id = formId();
    var form = id && document.forms[id];
    var btn = mainButton();
    if (!form || !btn) return;
    if (!purchaseConsistent()) return; // variante aún resolviéndose: el cliente puede volver a pulsar en un instante
    if (form.checkValidity && !form.checkValidity()) { form.reportValidity(); return; }
    S.busy = true;
    window.setTimeout(function () { if (S.busy) endBusy(false); }, 10000); // red de seguridad
    cta.setAttribute('aria-busy', 'true');
    if (form.requestSubmit) form.requestSubmit(btn); else btn.click();
  });

  function endBusy(ok, message) {
    var b = bar();
    S.busy = false;
    if (!b) return;
    var cta = b.querySelector('[data-ko-cta]');
    cta.removeAttribute('aria-busy');
    if (ok) {
      b.classList.add('is-done');
      b.querySelector('[data-ko-cta-label]').textContent = str('done', 'Añadido');
      window.setTimeout(function () { b.classList.remove('is-done'); reflect(); }, 1400);
    } else {
      reflect();
      if (message) {
        var title = b.querySelector('[data-ko-title]');
        if (title) {
          var prev = title.textContent;
          title.textContent = message;
          title.classList.add('is-error');
          window.setTimeout(function () { title.textContent = prev; title.classList.remove('is-error'); }, 3500);
        }
      }
    }
  }
  document.addEventListener('variant:add', function () { if (S.busy) endBusy(true); });
  document.addEventListener('cart:error', function (e) { if (S.busy) endBusy(false, e.detail && e.detail.error); });

  // Sin talla elegida, el tema escribe ?variant=<talla por defecto>: lo quitamos para que un refresh no la dé por elegida
  document.addEventListener('variant:change', function (e) {
    var t = e.target;
    var id = formId();
    if (!id || !t || !t.getAttribute || t.getAttribute('id') !== id) return; // solo la ficha principal
    if (S.pending && resolved()) setPending(false);
    applyGate(); // siempre: recalcula gate, botones y bloqueo de compra dinámica
    if (!S.gated) return;
    try {
      var u = new URL(window.location.href);
      if (u.searchParams.has('variant')) {
        u.searchParams.delete('variant');
        window.history.replaceState({}, '', u.toString());
      }
    } catch (e) {}
  });

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('orientationchange', schedule);

  /* --------------------------------------- re-renders del tema (observador) */
  var queued = false;
  var observer = new MutationObserver(function () {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      applyGate();
      schedule();
      observer.takeRecords();
    });
  });

  function start() {
    applyGate();
    schedule();
    observer.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  /* ----------------------------------------------- elemento <ko-sticky-atc> */
  if (!window.customElements.get('ko-sticky-atc')) {
    window.customElements.define('ko-sticky-atc', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        // Re-render del tema: la barra nueva nace ya en el estado correcto, sin animar otra vez
        var wasOn = document.documentElement.classList.contains('ko-sticky-on');
        this.classList.add('ko-no-anim');
        if (wasOn) this.classList.add('is-visible');
        applyGate();
        updateVisibility();
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () { self.classList.remove('ko-no-anim'); });
        });
      }
    });
  }
})();
